// extracted by mini-css-extract-plugin
module.exports = {"root":"social-media_root__DHcXi","icon":"social-media_icon__VntG2"};